import { ProfileModel } from './profile.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class VisitModel {
    id: number;
    profile_id: number;
    name: string;
    phone_no: string;
    mail_address: string;
    room_no: string;
    created_date: Date | string;
    start_date: Date | string;
    end_date: Date | string;
    point: number;
    voucher_no: string;
    id_no: string;
    allergy: boolean;
    allergy_description: string;
    vehicle_no: string;
    passport_front_image_url: string;
    passport_back_image_url: string;
    email_permission: boolean;
    invoice_info: boolean;
    company_name: string;
    invoice_id_no: string;
    tax_area: string;
    tax_no: string;
    company_address: string;
    invoice_mail: string;
    approval_status: string;
    approval_time: Date;
    approval_by_id: number;
    approval_by_name: string;
    night: number;
    total_points: number;

    constructor(profile: ProfileModel) {

        // Add this when you create this class
        this.room_no = '';
        this.start_date = new Date();
        this.end_date = new Date();
        this.night = 0;
        // End

        this.id = 0;
        this.profile_id = 0;
        this.name = `${profile.first_name} ${profile.last_name}`;
        this.phone_no = profile.phone_no;
        this.mail_address = profile.e_mail;
        this.created_date = new Date();
        this.point = 0;
        this.voucher_no = '';
        this.id_no = profile.id_no;
        this.allergy = profile.allergy;
        this.allergy_description = profile.allergy_description;
        this.vehicle_no = profile.vehicle_no;
        this.passport_front_image_url = profile.passport_front_image_url;
        this.passport_back_image_url = profile.passport_back_image_url;
        this.email_permission = profile.email_permission;
        this.invoice_info = profile.invoice_info;
        this.company_name = profile.company_name;
        this.invoice_id_no = profile.invoice_id_no;
        this.tax_area = profile.tax_area;
        this.tax_no = profile.tax_no;
        this.company_address = profile.company_address;
        this.invoice_mail = profile.invoice_mail;
        this.approval_status = '';
        this.approval_time = new Date();
        this.approval_by_id = 0;
        this.approval_by_name = '';
        this.total_points = 0;
    }
}
